<template>
  <div class="page-kln-quizzes">
    <c-modal-message
        :need-comment="needComment" :hide.sync="hide" :comment.sync="comment"
        :percent="result.points" :state.sync="state" :modal-type="modalType"/>
    <c-left-side-bar :step="4" :is-need-to-wait="true" :is-logout.sync="isLogout"/>
    <!--    <c-timer-modal />-->
    <n-loader :loading="$var('load')"/>
    <div class="mid-container">
      <div v-if="!timerCheck & !znanyCheck" class="mid-side">
        <div class="mid-top">
          <c-mid-head :h1="headers.title" :h2="headers.type"/>
          <p class="quiz-top-button" @click="showIgnorePage">Изменить</p>
        </div>
        <div class="list-actions">
          <p v-if="!isAbleToIgnore" @click="chooseAll">Выбрать всё</p>
          <p v-if="!isAbleToIgnore" @click="rejectChooseAll">Снять выделение</p>
        </div>
        <ul v-if="isAbleToIgnore" :key="$var('reload')" class="questions-list">
          <li v-for="item in questions" :key="item.id" class="question-row">
            <div v-if="!item.parentId && !item.isMemo" class="question-label"
                 @click="showModal(isIgnored(item) ? 'restoreQuestion' : 'deleteQuestion', item.id)">
              <div class="image-place">
                <img :src="isIgnored(item) ? iconPlus : iconMinus" alt="">
              </div>
              <p>{{ item.title }}</p>
            </div>
            <div v-if="!item.parentId && item.subquestions.length > 0 && !item.isMemo" class="sub-questions">
              <div
                  v-for="(subItem, index) in item.subquestions" :key="index" class="sub-question-label"
                  @click="showModal(isIgnored(subItem) ? 'restoreQuestion' : 'deleteQuestion', subItem.id)">
                <div class="image-place">
                  <img :src="isIgnored(subItem) ? iconPlus : iconMinus" alt="">
                </div>
                <p>{{ subItem.title }}</p>
              </div>
            </div>
          </li>
        </ul>
        <ul v-else :key="$var('reload')" class="questions-list">
          <li v-for="item in questions" :key="item.id" class="question-row" :class="{'ignored': isIgnored(item)}">
            <label v-if="!item.parentId" class="question-label">
              <input v-if="!item.isMemo && !item.isTimerNeeds" type="checkbox" :checked="isChecked(item)"
                     @click="answerClick(item.id, false, item)">
              <span v-if="item.isTimerNeeds" class="timer">
                <img :src="iconTimer" alt="">
              </span>
              <span :class="{'memo': item.isMemo}">{{ item.title }}</span>
            </label>
            <div v-if="!item.parentId && item.subquestions.length > 0" class="sub-questions">
              <label v-for="(subItem, index) in item.subquestions" :key="index" class="sub-question-label"
                     :class="{'ignored': isIgnored(subItem)}">
                <input
                    v-if="!subItem.isMemo && !item.isTimerNeeds" type="checkbox"
                    :checked="isChecked(subItem)" @click="answerClick(subItem.id, false, subItem)">
                <span :class="{'memo': subItem.isMemo}">{{ subItem.title }}</span>
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="category.formula === 1 || category.formula === 2">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '1'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeOne) }}</p>
                      <div class="text">
                        Стандарт: 18с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeOne" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '2'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers2" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeTwo) }}</p>
                      <div class="text">
                        Стандарт: 18с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeTwo" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '3'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers3" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeThree) }}</p>
                      <div class="text">
                        Стандарт: 10с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeThree" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '4'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers4" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFour) }}</p>
                      <div class="text">
                        Стандарт: 35-50с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFour" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
        </div>
      </div>
      <div v-if="category.formula === 3">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs2" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '4'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers4" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFour) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFour" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '5'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers5" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFive) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>

                  <input v-model="averageTimeFive" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
        </div>
      </div>
      <div v-if="category.formula === 4">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs7" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '4'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers4" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFour) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFour" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
        </div>
      </div>
      <div v-if="category.formula === 5">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs3" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '4'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers4" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFour) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFour" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '5'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers5" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFive) }}</p>
                      <div class="text">
                        Стандарт: 35-50с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFive" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
          <n-input
              v-model="grade"
              title="Производительность"
              @input="handleInput"
          />
        </div>
      </div>
      <div v-if="category.formula === 6">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs4" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '4'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers4" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFour) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFour" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '5'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers5" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFive) }}</p>
                      <div class="text">
                        Стандарт: 35-50с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFive" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '8'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers8" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeEight) }}</p>
                      <div class="text">
                        Стандарт: 3:30мин(210с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeEight" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
          <n-input
              v-model="grade"
              title="Производительность"
              @input="handleInput"
          />
        </div>
      </div>
      <div v-if="category.formula === 7">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs5" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '5'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers5" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFive) }}</p>
                      <div class="text">
                        Стандарт: 35-50с
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFive" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '3'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers3" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeThree) }}</p>
                      <div class="text">
                        Стандарт: 3мин(180с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeThree" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '4'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers4" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeFour) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeFour" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
          <n-input
              v-model="grade"
              title="Производительность"
              @input="handleInput"
          />
        </div>
      </div>
      <div v-if="category.formula === 8">
        <div v-if="timerCheck" class="mid-side">
          <div class="mid-top" style="display: block">
            <c-mid-head h1="Таймер"/>
            <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
              <n-tabs :data="tabs6" state name="resultStatus">
                <template #tab="{ item }">
                  <div class="tablSel" @click="handleTabChange(item.name)">{{ item.title }}</div>
                </template>
              </n-tabs>
            </div>
            <n-form>
              <div v-if="selectedTab === '1'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeOne) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeOne" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '2'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers2" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeTwo) }}</p>
                      <div class="text">
                        Стандарт: 2мин(120с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeTwo" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '3'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers3" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeThree) }}</p>
                      <div class="text">
                        Стандарт: 3мин(180с)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeThree" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '6'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers6" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeSix) }}</p>
                      <div class="text">
                        Стандарт: 35-50c
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeSix" type="hidden"/>
                </n-items>
              </div>
              <div v-if="selectedTab === '7'">
                <n-items>
                  <div class="block">
                    <div class="timer">
                      <div v-for="(timer, index) in timers7" :key="index">
                        <div class="onetimer">
                          <n-button :class="{'start': !timer.running, 'stop': timer.running}"
                                    @click="toggleTimer(selectedTab, index)">
                            {{ timer.running ? "Стоп" : "Старт" }}
                          </n-button>
                          <p>{{ formattedTime(timer.time) }}</p>
                          <n-button @click="resetTimer(selectedTab, index)">Сброс</n-button>
                        </div>
                      </div>
                    </div>
                    <div class="average">
                      <div>Среднее значение:</div>
                      <p>{{ formattedTime(averageTimeSeven) }}</p>
                      <div class="text">
                        Стандарт: 3:30мин(210c)
                      </div>
                    </div>
                  </div>
                  <input v-model="averageTimeSeven" type="hidden"/>
                </n-items>
              </div>
            </n-form>
          </div>
          <n-input
              v-model="grade"
              title="Производительность"
              @input="handleInput"
          />
        </div>
      </div>
      <div v-if="znanyCheck" class="mid-side">
        <div class="mid-top" style="display: block">
          <c-mid-head h1="Теоретические знания менеджера"/>
          <div class="tabs" style="margin-top: 20px; margin-bottom: 20px">
            <n-tabs :data="categories">
              <template #tab="{ item }">
                <div
                  class="tablSel"
                  :class="{ active: selectedCategoryTab === item.id }"
                  @click="handleCategoryTabChange(item.name)"
                >
                  {{ item.title }}
                </div>
              </template>
            </n-tabs>
          </div>
          <n-form>
            <div
              v-for="category in categories"
              :key="category.name"
              v-if="selectedCategoryTab === category.name"
            >
              <table class="question-table">
                <thead>
                  <tr>
                    <th>Вопрос</th>
                    <th class="col-check">Да</th>
                    <th class="col-check">Нет</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(q, index) in category.questions" :key="index">
                    <!-- ВОПРОС -->
                  <td>
                    <textarea
                        v-model="q.title"
                        placeholder="Введите вопрос"
                        class="question-input"
                    />
                    </td>

                  <!-- ДА -->
                  <td class="center">
                    <input
                        type="checkbox"
                        :checked="q.answer === true"
                        @change="setAnswer(category.name, index, true)"
                    />
                  </td>

                  <!-- НЕТ -->
                  <td class="center">
                    <input
                        type="checkbox"
                        :checked="q.answer === false"
                        @change="setAnswer(category.name, index, false)"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </n-form>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="right-side">
        <div>
          <div class="content">
            <div class="content-user">
              <p>{{ user.fullName }}</p>
              <p>Табельный номер: {{ user.personnelNumber }}</p>
            </div>
            <div class="actions">
              <n-button flat class="finish cancel" @click="showModal('cancel')">Отменить Оценку</n-button>
              <n-button flat class="finish" @click="showModal('finish')">Завершить Оценку</n-button>
            </div>
          </div>
          <div class="category-block">
            <p>{{ category.parent?.[0]?.title }}</p>
            <p>{{ category.title }}</p>
          </div>
          <div class="sections">
            <h3>Все разделы</h3>
            <ul class="section-list">
              <li
                  v-for="item in quizzes" :key="item.id" class="section-row"
                  :class="{'active': item.id === quiz.id && timerCheck === false && znanyCheck === false, 'incorrect': item.haveIncorrect}"
                  @click="saveAnswers(false, false, item)">
                <div class="left-part">
                  <!--                  <div class="icon-place">-->
                  <!--                    <div class="image-place">-->
                  <!--                      <img :src="item.image" alt="" class="icon">-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="section-text">
                    <p>{{ category.title }}</p>
                    <p class="main">{{ item.title }}</p>
                  </div>
                </div>
                <div class="right-part">
                  <img :src="sectionRow" alt="">
                </div>
              </li>
            </ul>
          </div>
          <div class="sections">
            <h3>Таймер</h3>
            <ul class="section-list" style="height: 10vh; overflow: hidden; margin-bottom: 15px;">
              <li
                  v-for="item in quizzes2" :key="item.id" class="section-row"
                  :class="{'active': timerCheck}" @click="checkTimer">
                <div class="left-part">
                  <div class="icon-place">
                    <div class="image-place">
                      <img :src="timerIcon" alt="" class="icon">
                    </div>
                  </div>
                  <div class="section-text">
                    <p>Timer</p>
                    <p class="main">{{ item.title }}</p>
                  </div>
                </div>
                <div class="right-part">
                  <img :src="sectionRow" alt="">
                </div>
              </li>
            </ul>
          </div>
          <div class="sections">
            <h3>ТЗМ</h3>
            <ul class="section-list" style="height: 10vh; overflow: hidden; margin-bottom: 15px;">
              <li
                v-for="item in quizzes2" :key="item.id" class="section-row"
                :class="{'active': znanyCheck}" @click="checkZnany">
                <div class="left-part">
                  <div class="icon-place">
                    <div class="image-place">
                      <img :src="znanyIcon" alt="" class="icon">
                    </div>
                  </div>
                  <div class="section-text">
                    <p>ТЗМ</p>
                    <p class="main">Теоритические знания менеджера</p>
                  </div>
                </div>
                <div class="right-part">
                  <img :src="sectionRow" alt="">
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="buttons">
          <n-button class="button interrupt" @click="showModal('interrupt')">Прервать</n-button>
          <n-button class="button next" @click="saveAnswers(false)">Далее</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import categoryIcon from 'assets/categoryIcon/culture-icon.png'
import sectionRow from 'assets/sectionRow/section-row.png'
import iconPlus from 'assets/icon-plus.svg'
import iconMinus from 'assets/icon-minus.svg'
import iconTimer from 'assets/icon-timer.svg'
import iconTimerCorrect from 'assets/icon-timer-correct.svg'
import iconTimerIncorrect from 'assets/icon-timer-incorrect.svg'
import timerIcon from 'assets/timer_icon.svg'
import znanyIcon from 'assets/klnIcons/znany.png'
import {ref,} from 'vue'

export default {
  name: 'PageTimerQuizzes',
  props: {},
  data() {
    return {
      questions: [],
      answers: {},
      category: {},
      needComment: false,
      comment: '',
      grade: 0,
      deletedQuestionId: null,
      quizzes: [],
      time: {},
      selectedCategoryTab: 1,

      categories: [
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
        {
          name: 0,
          title: '',
          questions: [
            { title: '', answer: null },
            { title: '', answer: null },
            { title: '', answer: null },
          ],
        },
      ],
      theoryManagerCategory:{},
      quizzes2: [
        {id: 1, title: 'Таймер',},
      ],
      tabs: [
        {name: '1', title: '10:1',},
        {name: '2', title: '4:1',},
        {name: '3', title: '3:1',},
        {name: '4', title: 'Линия MFY',},
      ],
      tabs2: [
        {name: '4', title: 'Прилавок',},
        {name: '5', title: 'Drive',},
      ],
      tabs3: [
        {name: '4', title: 'Прилавок',},
        {name: '5', title: 'MFY',},
      ],
      tabs4: [
        {name: '4', title: 'Прилавок',},
        {name: '5', title: 'MFY',},
        {name: '8', title: 'Delivery',},
      ],
      tabs5: [
        {name: '4', title: 'Прилавок',},
        {name: '3', title: 'Cafe',},
        {name: '5', title: 'MFY',},
      ],
      tabs6: [
        {name: '1', title: 'Прилавок',},
        {name: '2', title: 'Drive',},
        {name: '3', title: 'Cafe',},
        {name: '6', title: 'MFY',},
        {name: '7', title: 'Delivery',},
      ],
      tabs7: [
        {name: '4', title: 'Прилавок',},
      ],

      timers: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers2: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers3: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers4: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers5: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers6: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers7: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timers8: [
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
        {time: 0, running: false,},
      ],
      timerIntervals: [],

      selectedTab: '1',
      timerCheck: false,
      znanyCheck: false,
      quiz: {},
      result: {},
      headers: {title: 'Квиз', type: 'Теория',},
      hide: true,
      state: '',
      quizzesCount: 0,
      finishedQuizzes: 0,
      isAbleToIgnore: false,
      ignoredQuestions: {},
      modalType: 'interrupt',
      clickCount: 0,
      user: {},
      isLogout: false,
      categoryIcon,
      sectionRow,
      iconPlus,
      iconMinus,
      timerIcon,
      znanyIcon,
      // iconTimer,
      // iconTimerCorrect,
      // iconTimerIncorrect,
    }
  },
  computed: {
    categoryId() {
      return this.$route.query.categoryId
    },
    resultId() {
      return this.$route.query.resultId
    },
    averageTimeOne() {
      return this.calculateAverage(this.timers)
    },
    averageTimeTwo() {
      return this.calculateAverage(this.timers2)
    },
    averageTimeThree() {
      return this.calculateAverage(this.timers3)
    },
    averageTimeFour() {
      return this.calculateAverage(this.timers4)
    },
    averageTimeFive() {
      return this.calculateAverage(this.timers5)
    },
    averageTimeSix() {
      return this.calculateAverage(this.timers6)
    },
    averageTimeSeven() {
      return this.calculateAverage(this.timers7)
    },
    averageTimeEight() {
      return this.calculateAverage(this.timers8)
    },

  },
  watch: {
    quiz() {
      this.loadQuestions()
      this.getHeaders()
    },
    isLogout() {
      if (this.isLogout) {
        this.saveAnswers(true)
      }
    },
    state() {
      if (this.state === 'deleteQuestion' || this.state === 'restoreQuestion') {
        this.answerClick(this.deletedQuestionId + '', true)
      } else {
        if (this.state === 'interrupt') {
          this.saveAnswers(true)
        } else {
          if (this.state === 'finish') {
            this.finish()
          }
          if (this.state === 'cancel') {
            this.cancelQuiz()
          }
        }
      }
      this.state = ''
    },
  },
  created() {
    this.loadCategory()
  },
  methods: {
    commaToDot(value) {
      if (value === null || value === undefined) return value

      return Number(String(value).replace(',', '.'))
    },
    handleInput(value) {
      value = this.commaToDot(value)

      const numeric = Number(value)
      if (!isNaN(numeric)) {
        if (numeric > 100) this.grade = 100
        else if (numeric < 0) this.grade = 0
        else this.grade = numeric
      }
    },
    handleTabChange(newTab) {
      this.selectedTab = newTab
    },
    handleCategoryTabChange(tab) {
      this.selectedCategoryTab = tab
    },
    calculateAverage(timers) {
      const times = timers.map((t) => t.time).filter((t) => t > 0)
      if (times.length === 0) return 0
      return Math.floor(times.reduce((a, b) => a + b, 0) / times.length)
    },
    toggleTimer(tabIndex, index) {
      const timersArray = this.getTimersArray(tabIndex)
      if (timersArray[index].running) {
        this.stopTimer(tabIndex, index)
      } else {
        this.startTimer(tabIndex, index)
      }
    },

    startTimer(tabIndex, index) {
      const timersArray = this.getTimersArray(tabIndex)
      if (!timersArray[index].running) {
        timersArray[index].running = true
        this.timerIntervals[`${tabIndex}-${index}`] = setInterval(() => {
          timersArray[index].time++
        }, 1000)
      }
    },

    stopTimer(tabIndex, index) {
      const key = `${tabIndex}-${index}`
      const timersArray = this.getTimersArray(tabIndex)
      timersArray[index].running = false
      clearInterval(this.timerIntervals[key])
      this.timerIntervals[key] = null
    },

    resetTimer(tabIndex, index) {
      this.stopTimer(tabIndex, index)
      const timersArray = this.getTimersArray(tabIndex)
      timersArray[index].time = 0
    },

    getTimersArray(tabIndex) {
      switch (tabIndex) {
        case '1':
          return this.timers
        case '2':
          return this.timers2
        case '3':
          return this.timers3
        case '4':
          return this.timers4
        case '5':
          return this.timers5
        case '6':
          return this.timers6
        case '7':
          return this.timers7
        case '8':
          return this.timers8
        default:
          return []
      }
    },

    formattedTime(time) {
      const minutes = Math.floor(time / 60)
      const seconds = time % 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    },
    loadQuizzes() {
      this.$var('load', true)
      const query = 'resultId=' + this.resultId

      $api.timerquizzes.get(this.category.id).all().with('haveIncorrect').query(query).then((response) => {
        this.quizzes = response.data.content
        this.quizzesCount = this.quizzes.length
        this.quiz = this.quizzes[this.finishedQuizzes]
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadQuestions() {
      this.$var('load', true)
      $api.timerquestions.get(this.quiz.id).all().with('subquestions').then((response) => {
        this.questions = response.data.content
        $n.map(this.questions, (elem) => {
          this.answers = {
            ...this.answers,
            [elem.id + '']: {
              value: false,
              ignored: false,
            },
          }
        })
        this.loadResult()
      }).catch(() => {
        this.$var('load', false)
      })
    },
    loadResult() {
      $api.timerresults.get(this.resultId).with('answers').with('timer').with('theoryQuestion').then((response) => {
        this.result = response.data.content
        if (this.category.formula === 1 && this.result.timer && this.result.timer?.timers) {
          this.timers = this.result.timer?.timers.timers || 0
          this.timers2 = this.result.timer?.timers.timers2 || 0
          this.timers3 = this.result.timer?.timers.timers3 || 0
          this.timers4 = this.result.timer?.timers.timers4 || 0
        }
        if (this.category.formula === 2 && this.result.timer && this.result.timer?.timers) {
          this.timers = this.result.timer?.timers.timers || 0
          this.timers2 = this.result.timer?.timers.timers2 || 0
          this.timers3 = this.result.timer?.timers.timers3 || 0
          this.timers4 = this.result.timer?.timers.timers4 || 0
        }
        if (this.category.formula === 3 && this.result.timer && this.result.timer?.timers) {
          this.timers4 = this.result.timer?.timers.timers4 || 0
          this.timers5 = this.result.timer?.timers.timers5 || 0
        }
        if (this.category.formula === 4 && this.result.timer && this.result.timer?.timers) {
          this.timers4 = this.result.timer?.timers.timers4 || 0
        }
        if (this.category.formula === 5 && this.result.timer && this.result.timer?.timers) {
          this.timers4 = this.result.timer?.timers.timers4 || 0
          this.timers5 = this.result.timer?.timers.timers5 || 0
          this.grade = this.result.timer?.grade || 0
        }
        if (this.category.formula === 6 && this.result.timer && this.result.timer?.timers) {
          this.timers8 = this.result?.timer?.timers.timers3 || 0
          this.timers4 = this.result?.timer?.timers.timers4 || 0
          this.timers5 = this.result?.timer?.timers.timers5 || 0
          this.grade = this.result.timer?.grade || 0
        }
        if (this.category.formula === 7 && this.result.timer && this.result.timer?.timers) {
          this.timers3 = this.result.timer?.timers.timers3 || 0
          this.timers4 = this.result.timer?.timers.timers4 || 0
          this.timers5 = this.result.timer?.timers.timers5 || 0
          this.grade = this.result.timer?.grade || 0
        }
        if (this.category.formula === 8 && this.result.timer && this.result.timer?.timers) {
          this.timers = this.result.timer?.timers.timers || 0
          this.timers2 = this.result.timer?.timers.timers2 || 0
          this.timers3 = this.result.timer?.timers.timers3 || 0
          this.timers6 = this.result.timer?.timers.timers6 || 0
          this.timers7 = this.result.timer?.timers.timers7 || 0
          this.grade = this.result.timer?.grade || 0
        }
        const existedAnswers = response.data.content.answers
        if (existedAnswers) {
          $n.map(existedAnswers, (elem) => {
            this.answers = {
              ...this.answers,
              [elem.questionId + '']: {
                value: elem.value,
                ignored: elem.ignored,
              },
            }
          })
        }
        const theoryQuestions = response.data.content.theoryQuestion || []

// Пробегаем по всем категориям
        this.categories.forEach(category => {
          // Фильтруем вопросы, которые относятся к этой категории
          const questionsForCategory = theoryQuestions.filter(
              q => String(q.managerCategoryId) === String(category.name)
          )

          if (questionsForCategory.length) {
            // Создаем массив вопросов для категории
            category.questions = [0,1,2].map(i => {
              const q = questionsForCategory.find(q => q.order === i)
              return { title: q?.title || '', answer: q?.answer ?? null }
            })
          } else {
            // Если вопросов нет, оставляем пустые шаблонные
            if (!category.questions.length) {
              category.questions = [
                { title: '', answer: null },
                { title: '', answer: null },
                { title: '', answer: null }
              ]
            }
          }
        })
        this.loadUser(this.result.userId)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadUser(userId) {
      if (userId) {
        $api.users.get(userId).then((response) => {
          this.user = response.data.content
        })
      }
    },
    getHeaders() {
      const type = this.quiz.type === 'theory' ? 'Теория' : 'Практика'
      this.headers = {title: this.quiz.title, type: type,}
    },
    showModal(modalType, deletedQuestionId = null) {
      if (modalType === 'finish') {
        this.saveAnswers(false, false, null, true)
        setTimeout(() => {
          this.loadResult()
          this.needComment = true
        }, 1000)
      }
      this.modalType = modalType
      this.deletedQuestionId = deletedQuestionId + ''
      this.hide = false
    },
    next(quiz) {
      const query = 'resultId=' + this.resultId
      $api.timerquizzes.get(this.category.id).all().with('haveIncorrect').with('theoryQuestion').query(query).then((response) => {
        this.quizzes = response.data.content
        if (quiz) {
          this.quiz = this.quizzes[this.quizzes.findIndex((elem) => {
            return elem.id === quiz.id
          })]
        } else {
          const nextIndex = this.quizzes.findIndex((elem) => {
            return elem.id === this.quiz.id
          })
          if (nextIndex + 1 > this.quizzes.length - 1) {
            this.quiz = this.quizzes?.[0]
          } else {
            this.quiz = this.quizzes?.[nextIndex + 1]
          }
        }
      })
    },
    saveAnswers(interrupting = false, finishing = false, toQuiz = null, notGoNext = false) {
      this.timerCheck = false
      this.znanyCheck = false
      this.$var('load', true)

      if (this.category.formula === 1) {
        this.time = {
          timer: {
            timers: this.timers,
            timers2: this.timers2,
            timers3: this.timers3,
            timers4: this.timers4,
          },
          resultId: this.resultId,
          averageTimeOne: this.averageTimeOne,
          averageTimeTwo: this.averageTimeTwo,
          averageTimeThree: this.averageTimeThree,
          averageTimeFour: this.averageTimeFour,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 2) {
        this.time = {
          timer: {
            timers: this.timers,
            timers2: this.timers2,
            timers3: this.timers3,
            timers4: this.timers4,
          },
          resultId: this.resultId,
          averageTimeOne: this.averageTimeOne,
          averageTimeTwo: this.averageTimeTwo,
          averageTimeThree: this.averageTimeThree,
          averageTimeFour: this.averageTimeFour,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 3) {
        this.time = {
          timer: {
            timers4: this.timers4,
            timers5: this.timers5,
          },
          resultId: this.resultId,
          averageTimeFour: this.averageTimeFour,
          averageTimeFive: this.averageTimeFive,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 4) {
        this.time = {
          timer: {
            timers4: this.timers4,
          },
          resultId: this.resultId,
          averageTimeFour: this.averageTimeFour,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 5) {
        this.time = {
          timer: {
            timers4: this.timers4,
            timers5: this.timers5,
          },
          resultId: this.resultId,
          averageTimeFour: this.averageTimeFour,
          averageTimeFive: this.averageTimeFive,
          grade: this.grade,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 6) {
        this.time = {
          timer: {
            timers3: this.timers8,
            timers4: this.timers4,
            timers5: this.timers5,
          },
          resultId: this.resultId,
          averageTimeFive: this.averageTimeFive,
          averageTimeFour: this.averageTimeFour,
          averageTimeThree: this.averageTimeEight,
          grade: this.grade,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 7) {
        this.time = {
          timer: {
            timers3: this.timers3,
            timers4: this.timers4,
            timers5: this.timers5,
          },
          resultId: this.resultId,
          averageTimeThree: this.averageTimeThree,
          averageTimeFour: this.averageTimeFour,
          averageTimeFive: this.averageTimeFive,
          grade: this.grade,
          answers: this.answers,
          theoryManager: this.categories,

        }
      }
      if (this.category.formula === 8) {
        this.time = {
          timer: {
            timers: this.timers,
            timers2: this.timers2,
            timers3: this.timers3,
            timers6: this.timers6,
            timers7: this.timers7,
          },
          resultId: this.resultId,
          averageTimeOne: this.averageTimeOne,
          averageTimeTwo: this.averageTimeTwo,
          averageTimeThree: this.averageTimeThree,
          averageTimeSix: this.averageTimeSix,
          averageTimeSeven: this.averageTimeSeven,
          grade: this.grade,
          answers: this.answers,
          theoryManager: this.categories,
        }
      }

      $api.timeranswers.save(this.resultId, this.quiz.id, this.time).then((response) => {
        if (interrupting) {
          if (this.isLogout) {
            this.$app.auth.logout(true)
          } else {
            this.$router.push({name: 'kln-timer-info',})
          }
        } else {
          if (!notGoNext) {
            this.next(toQuiz)
          }
        }
        if (finishing) {
          if (this.category.formula === 1) {
            this.time = {
              timer: {
                timers: this.timers,
                timers2: this.timers2,
                timers3: this.timers3,
                timers4: this.timers4,
              },
              resultId: this.resultId,
              averageTimeOne: this.averageTimeOne,
              averageTimeTwo: this.averageTimeTwo,
              averageTimeThree: this.averageTimeThree,
              averageTimeFour: this.averageTimeFour,
              status: 'unaccepted',
              comment: this.comment,
              answers: this.answers,
              theoryManager: this.categories,

            }
          }
          if (this.category.formula === 2) {
            this.time = {
              timer: {
                timers: this.timers,
                timers2: this.timers2,
                timers3: this.timers3,
                timers4: this.timers4,
              },
              resultId: this.resultId,
              averageTimeOne: this.averageTimeOne,
              averageTimeTwo: this.averageTimeTwo,
              averageTimeThree: this.averageTimeThree,
              averageTimeFour: this.averageTimeFour,
              status: 'unaccepted',
              comment: this.comment,
              answers: this.answers,
              theoryManager: this.categories,

            }
          }
          if (this.category.formula === 3) {
            this.time = {
              timer: {
                timers4: this.timers4,
                timers5: this.timers5,
              },
              resultId: this.resultId,
              averageTimeFour: this.averageTimeFour,
              averageTimeFive: this.averageTimeFive,
              status: 'unaccepted',
              comment: this.comment,
              answers: this.answers,
              theoryManager: this.categories,

            }
          }
          if (this.category.formula === 4) {
            this.time = {
              timer: {
                timers4: this.timers4,
              },
              resultId: this.resultId,
              averageTimeFour: this.averageTimeFour,
              status: 'unaccepted',
              comment: this.comment,
              answers: this.answers,
              theoryManager: this.categories,

            }
          }
          if (this.category.formula === 5) {
            this.time = {
              timer: {
                timers4: this.timers4,
                timers5: this.timers5,
              },
              resultId: this.resultId,
              averageTimeFour: this.averageTimeFour,
              averageTimeFive: this.averageTimeFive,
              grade: this.grade,
              status: 'unaccepted',
              answers: this.answers,
              comment: this.comment,
              theoryManager: this.categories,

            }
          }
          if (this.category.formula === 6) {
            this.time = {
              timer: {
                timers3: this.timers8,
                timers4: this.timers4,
                timers5: this.timers5,
              },
              resultId: this.resultId,
              averageTimeFive: this.averageTimeFive,
              averageTimeFour: this.averageTimeFour,
              averageTimeThree: this.averageTimeEight,
              grade: this.grade,
              status: 'unaccepted',
              answers: this.answers,
              comment: this.comment,
              theoryManager: this.categories,

            }
          }
          if (this.category.formula === 7) {
            this.time = {
              timer: {
                timers3: this.timers3,
                timers4: this.timers4,
                timers5: this.timers5,
              },
              resultId: this.resultId,
              averageTimeThree: this.averageTimeThree,
              averageTimeFour: this.averageTimeFour,
              averageTimeFive: this.averageTimeFive,
              grade: this.grade,
              status: 'unaccepted',
              answers: this.answers,
              comment: this.comment,
              theoryManager: this.categories,

            }
          }

          if (this.category.formula === 8) {
            this.time = {
              timer: {
                timers: this.timers,
                timers2: this.timers2,
                timers3: this.timers3,
                timers6: this.timers6,
                timers7: this.timers7,
              },
              resultId: this.resultId,
              averageTimeOne: this.averageTimeOne,
              averageTimeTwo: this.averageTimeTwo,
              averageTimeThree: this.averageTimeThree,
              averageTimeFour: this.averageTimeSix,
              averageTimeFive: this.averageTimeSeven,
              grade: this.grade,
              status: 'unaccepted',
              answers: this.answers,
              comment: this.comment,
              theoryManager: this.categories,

            }
          }

          $api.timerresults.patch(this.resultId, this.time).then(() => {
            this.$router.push({ name: 'kln-timer-info', })
          }).finally(() => {
            this.$var('load', false)
          })
        }
      }).catch(() => {
        this.$var('load', false)
      })
    },
    checkTimer() {
      this.znanyCheck = false
      this.timerCheck = !this.timerCheck
    },
    checkZnany() {
      this.timerCheck = false
      this.znanyCheck = !this.znanyCheck
    },
    finish() {
      this.saveAnswers(false, true)
      this.$var('load', true)
    },
    isChecked(answer) {
      const id = answer.id.toString()
      let allChildsChecked = true
      const question = $n.find(this.questions, (e) => {
        if (e.id === answer.id) {
          return e
        }
      })
      const child = question?.subquestions
      $n.each(child, (e) => {
        if (!this.answers?.[e.id]?.value && !this.answers?.[e.id]?.ignored && !e.isMemo) {
          allChildsChecked = false
        }
      })

      if (child?.length > 0 && this.answers[question.id].value !== allChildsChecked) {
        this.answers = {
          ...this.answers,
          [question.id]: {
            ...this.answers[question.id],
            value: allChildsChecked,
          },
        }
      }

      return (this.answers?.[id] ? this.answers[id].value : false) || (allChildsChecked && child?.length > 0)
    },
    isIgnored(answer) {
      const id = answer.id.toString()
      return this.answers?.[id] ? this.answers[id].ignored : false
    },
    showIgnorePage() {
      if (this.clickCount === 0) {
        this.isAbleToIgnore = true
        this.clickCount++
      } else {
        this.isAbleToIgnore = false
        this.clickCount = 0
      }
    },
    turnOn(question, answer, isIgnored) {
      $n.map(question.subquestions, (e) => {
        this.answers[e.id] = {
          value: isIgnored ? false : !answer.value,
          ignored: isIgnored ? !answer.ignored : false,
        }
      })
    },
    answerClick(questionId, isIgnored, question = null) {
      if (!question) {
        question = $n.find(this.questions, (e) => {
          if (e.id + '' === questionId) {
            return e
          }
        })
      }
      if (question?.isParent) {
        const answer = this.answers[questionId]
        this.answers = {
          ...this.answers,
          [questionId]: {
            value: isIgnored ? false : !(this.answers[questionId]?.value),
            ignored: isIgnored ? !(this.answers[questionId]?.ignored) : false,
          },
        }
        this.turnOn(question, answer, isIgnored)
      } else {
        this.answers = {
          ...this.answers,
          [questionId]: {
            value: isIgnored ? false : !(this.answers[questionId]?.value),
            ignored: isIgnored ? !(this.answers[questionId]?.ignored) : false,
          },
        }
      }
    },
    loadCategory() {
      this.$var('load', true)
      $api.timercategories.get(this.categoryId).all().with('parent').with('theoryManager').then((response) => {
        this.category = response.data.content
        this.theoryManagerCategory = response.data.content.theoryManager
        this.selectedCategoryTab = this.theoryManagerCategory[0].id
        if (!this.categories.length || this.categories[0].title === '') {
          this.categories = this.theoryManagerCategory.map((item) => ({
            name: item.id,
            title: item.title,
            questions: [
              { title: '', answer: null },
              { title: '', answer: null },
              { title: '', answer: null },
            ],
          }))
        }
        if (this.category.formula === 7) {
          this.selectedTab = '4'
        }
        if (this.category.formula === 6) {
          this.selectedTab = '4'
        }
        if (this.category.formula === 5) {
          this.selectedTab = '4'
        }
        if (this.category.formula === 4) {
          this.selectedTab = '4'
        }
        if (this.category.formula === 3) {
          this.selectedTab = '4'
        }
        this.loadQuizzes()
      }).finally(() => {
      })
    },
    setAnswer(categoryName, questionIndex, value) {
      const category = this.categories.find(c => c.name === categoryName)

      if (!category) return

      const question = category.questions[questionIndex]

      // если кликнули на уже выбранный вариант → снимаем (null)
      if (question.answer === value) {
        question.answer = null
      } else {
        question.answer = value
      }
    },
    chooseAll() {
      $n.map(this.questions, (el) => {
        this.answers = {
          ...this.answers,
          [el.id]: {
            value: true,
            ignored: this.answers[el.id] ? this.answers[el.id].ignored : false,
          },
        }
      })
    },
    rejectChooseAll() {
      $n.map(this.questions, (el) => {
        this.answers = {
          ...this.answers,
          [el.id]: {
            value: false,
            ignored: this.answers[el.id] ? this.answers[el.id].ignored : false,
          },
        }
      })
    },
    cancelQuiz() {
      this.$var('load', true)
      $api.timerresults.cancel(this.result.id).then(() => {
        this.$router.push({name: 'kln-timer-info',})
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-kln-quizzes {
  display: flex;
  position: relative;
  min-height: 100vh;

  .mid-container {
    padding: 40px 20px 0 20px;
    background-color: #ffffff;
    width: 65vw;

    .mid-side {
      ::v-deep .n-input {
        width: 50%;
        padding-top: 45%;
      }

      .timer {
        width: 200px;

        .onetimer {
          height: 36px;
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          ::v-deep button.n-button.default {
            min-width: 70px;

            &.start {
              background-color: #1b4932;
              color: white;
            }

            &.stop {
              background-color: #f44336;
              color: white;
            }
          }

          p {
            width: 70px;
            text-align: center;
            font-size: 20px;
            font-weight: 600
          }

        }
      }

      .list-actions {
        margin: 30px 0 10px 0;
        cursor: pointer;
        color: var(--primary);
        text-decoration: underline;
        display: flex;
        justify-content: space-between;
      }

      .mid-top {
        display: flex;
        justify-content: space-between;

        ::v-deep .tabs .n-tabs > .n-tab {
          padding: 0;

          .tablSel {
            padding: 20px 15px;
            text-align: center;
          }
        }

        .quiz-top-button {
          cursor: pointer;
          text-decoration: underline;
          color: var(--primary);
          font-size: 1.05em;
        }
      }

      h1 {
        margin: 10px 0 30px 0;
        padding: 0;
        font-size: 32px;
        font-weight: bold;
        color: #292929;
      }
      .question-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;

        th, td {
          border: 1px solid #ccc;
          padding: 10px;
        }

        th {
          background: #f5f5f5;
          text-align: left;
        }

        .col-check {
          width: 80px;
          text-align: center;
        }

        .center {
          text-align: center;
        }
      }

      .question-input {
        width: 100%;
        min-height: 60px;
        resize: vertical;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: inherit;
      }
      .questions-list {
        list-style: none;
        height: calc(100vh / 1.4);
        overflow: auto;
        padding: 0;

        .question-row {
          margin: 28px 0 0 0;
          flex-shrink: 0;

          .sub-questions {
            padding: 10px 35px;

            .image-place {
              margin-right: 15px;
              width: 20px;
              height: 20px;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }

          .sub-question-label {
            margin-bottom: 5px;

            &.ignored {
              display: none;
            }

            &:last-child {
              margin-bottom: 0;
            }

            display: flex;
            align-items: center;

          }

          .question-label {
            display: flex;
            align-items: center;

            .image-place {
              margin-right: 15px;
              width: 20px;
              height: 20px;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }

          &.ignored {
            display: none;
          }

          .ignore-button {
            position: relative;
            background-color: red;
            color: red;
            width: 20px;
            height: 20px;
            margin: 0 14px 0 0;

            :before {
              content: '-';
              position: absolute;
              font-size: 2.0em;
              color: #ffffff;
              z-index: 9;
              width: 10px;
              height: 2px;
              left: 3px;
              top: -12px;
            }

            &.ignored {
              background-color: lightgreen;
              color: lightgreen;

              :before {
                content: '+';
                position: absolute;
                font-size: 1.2em;
                color: #ffffff;
                z-index: 9;
                width: 10px;
                height: 2px;
                left: 3px;
                top: -2px;
              }
            }
          }

          input {
            width: 20px;
            height: 20px;
            margin: 0 15px 0 0;
            flex-shrink: 0;
          }

          input:checked + label::before {
            background-color: var(--primary);
          }

          p {
            margin: 0;
            padding: 0;
            font-size: 17px;
            color: var(--secondary);
            flex: 2;
          }
        }
      }
    }
  }

  .right-container {
    padding: 0 20px;
    background-color: #FCFCFC;
    position: relative;

    .right-side {
      padding: 38px 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 100vh;
      position: relative;

      .content {
        margin-bottom: 15px;


        .actions {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          ::v-deep .finish.n-button {
            width: 42%;
          }
        }

        .finish {
          width: 150px;
          height: 40px;
          background-color: var(--secondary);
          color: #ffffff;
          font-weight: bold;
          font-size: 14px;
          border-radius: 8px;

          &.cancel {
            background-color: var(--danger);
          }
        }

        .content-user {
          margin-right: 45px;

          p {
            font-size: 1.05em;
            color: var(--secondary);

            &:last-child {
              font-size: 0.85em;
              color: #6D6F7B;
            }
          }
        }
      }

      .category-block {
        margin-bottom: 50px;

        p {
          font-size: 1.5em;
          font-weight: bold;
          color: var(--secondary);

          &:last-child {
            font-weight: normal;
            color: #626C77;
            font-size: 1.2em;
          }
        }
      }

      .sections {
        h3 {
          font-size: 17px;
          font-weight: bold;
          margin-bottom: 22px;
        }

        .section-list {
          list-style: none;
          margin: 0;
          padding: 0;
          height: 30vh;
          overflow: auto;

          .section-row {
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            padding-right: 56px;
            margin-bottom: 30px;
            border-radius: 12px;
            height: 66px;
            position: relative;

            &::before {
              position: absolute;
              content: '';
              height: 1px;
              bottom: -13px;
              left: 55px;
              right: 0;
              background-color: #E9E9EC;
              z-index: 9;
            }

            &.active {
              background-color: rgba(38, 79, 54, 0.2) !important;
            }

            &.incorrect {
              background-color: red;
            }

            .left-part {
              margin-left: 20px;
              display: flex;
              position: relative;
              align-items: center;
              justify-content: center;

              .icon-place {
                display: flex;
                background-color: #F6F6F6;
                border-radius: 12px;
                width: 64px;
                height: 64px;
                justify-content: center;
                align-items: center;
                margin-right: 12px;

                .image-place {
                  width: 44px;
                  height: 44px;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    aspect-ratio: auto;
                  }
                }
              }

              .section-text {
                p {
                  margin: 0;
                  padding: 0;
                  font-size: 14px;
                  color: #6D6F7B;

                  &.main {
                    font-size: 17px;
                    color: var(--secondary);
                  }
                }
              }
            }

            .right-part {
              position: relative;
              display: flex;
              align-items: center;

              img {
                width: 7px;
                height: 14px;
              }
            }
          }
        }
      }

      .buttons {
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .button {
          width: 190px;
          height: 50px;
          font-size: 17px;
          font-weight: bold;
          margin: 0 6px 0 0;
          background-color: #F2F3F7;
          border-radius: 8px;
          border: none;

          &.interrupt {
            color: #DB0007;
          }

          &.next {
            color: var(--secondary);
          }
        }
      }
    }
  }

  .memo {
    font-style: italic;
  }

  .block {
    display: flex;

    .average {
      width: 100%;
      text-align: center;
      margin-top: 20%;

      p {
        font-weight: 700;
        font-size: 40px;
      }
    }

    .timer {
      cursor: pointer;
      margin-right: 15px;
      width: 25px;
      height: 25px;

      .text {
        width: 200px;
        border-radius: 10px;
        height: 46px;
        background-color: #c9c9c9;
        text-align: center;
        padding-top: 10px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        flex-shrink: 0;
      }
    }
  }

}

p {
  margin: 0;
  padding: 0;
}
</style>
